'use client'
import { useState, useEffect } from 'react'
import Link from 'next/link'
import DealCard from '@/components/DealCard'

function getSessionToken() {
  try {
    const s = typeof window !== 'undefined' ? localStorage.getItem('fairfares_session') : null
    return s ? (JSON.parse(s)?.access_token ?? null) : null
  } catch { return null }
}

export default function AirlineDealsSection({ airlineName, dealCount = 0 }) {
  const [status, setStatus] = useState('loading')
  const [publicDeals, setPublicDeals] = useState([])
  const [lockedCount, setLockedCount] = useState(0)

  useEffect(() => {
    async function load() {
      try {
        const token = getSessionToken()
        const headers = token ? { Authorization: `Bearer ${token}` } : {}
        const res = await fetch('/api/deals', { headers })
        const { deals: allDeals } = await res.json()

        const al = airlineName.toLowerCase()
        const mine = allDeals.filter((d) => {
          if (!d.airline) return false
          const da = d.airline.toLowerCase()
          return da === al || al.startsWith(da + ' ')
        })

        setPublicDeals(mine.filter((d) => !d._locked))
        setLockedCount(mine.filter((d) => d._locked).length)
      } catch { /* show empty state */ }
      setStatus('done')
    }
    load()
  }, [airlineName])

  if (status === 'loading') {
    return (
      <div className="bg-white rounded-2xl border border-gray-200 p-6 text-center text-gray-400 text-sm animate-pulse">
        Loading deals…
      </div>
    )
  }

  if (publicDeals.length === 0) {
    return (
      <div className="bg-white rounded-2xl border border-gray-200 p-6 text-center space-y-3">
        <p className="text-sm text-gray-500">
          {dealCount > 0
            ? `We track ${dealCount} ${airlineName} deal${dealCount !== 1 ? 's' : ''}. Sign up to see what you qualify for.`
            : `No active deals for ${airlineName} right now — check back soon.`}
        </p>
        {dealCount > 0 && (
          <Link
            href="/signup"
            className="inline-block bg-blue-600 text-white text-sm font-bold px-5 py-2 rounded-xl hover:bg-blue-700 transition-colors"
          >
            Get free access →
          </Link>
        )}
      </div>
    )
  }

  return (
    <div className="space-y-3">
      {publicDeals.map((deal) => (
        <DealCard key={deal.id} deal={deal} />
      ))}
      {lockedCount > 0 && (
        <div className="rounded-2xl border border-blue-100 bg-blue-50 p-5 text-center">
          <p className="text-sm font-semibold text-blue-900 mb-1">
            🔒 {lockedCount} more deal{lockedCount !== 1 ? 's' : ''} — members only
          </p>
          <p className="text-xs text-blue-700 mb-3">
            Sign up free to unlock all prices, dates and airports.
          </p>
          <Link
            href="/signup"
            className="inline-block bg-blue-600 text-white text-sm font-bold px-5 py-2 rounded-xl hover:bg-blue-700 transition-colors"
          >
            Get free access →
          </Link>
        </div>
      )}
    </div>
  )
}
